<template>
    <div class="intro">
        <img src="static/apple-icon.png" alt="" />

        <template v-if="$utils.cookie('UserCookie')">
            欢迎来到血染钟楼助手，请创建[H]\加入[J]一个房间
            <span class="button" @click="toggleMenu"> <font-awesome-icon icon="cog" /> Menu </span>
        </template>
        <template v-else>
            为了更好的体验请您先
            <span class="button" @click="toggleModal('loginBox');">登录</span>
        </template>
        


        <div class="PCUrl">
            <template v-if="PCUrl">
                https://app.gamersky.com/db/clocktower/
                <span class="button" @click="$utils.copyUrl('https://app.gamersky.com/db/clocktower/')">
                    点击复制
                </span>
            </template>
            <template v-else>
                https://clocktower.vgnn.cn/
                <span class="button" @click="$utils.copyUrl('https://clocktower.vgnn.cn/')">
                    点击复制
                </span>
            </template>
        </div>
        <div class="statement">
            此为<a href="https://github.com/bra1n/townsquare" target="_blank">GitHub</a
            >开源工具，我们对其进行了修改和功能优化，工具中所有模组、卡组均由用户上传整理。本工具非官方项目，<a
                href="https://bloodontheclocktower.com/"
                target="_blank"
                >《血染钟楼》</a
            >桌游由Steven Medway设计，The Pandemonium Institute公司出品。
        </div>
        <div>
            <span class="button" @click="toggleModal('updateLog')">
                工具新功能更新日志
            </span>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
    methods: {
        ...mapMutations(["toggleMenu", "toggleModal"])
    },
    computed: {
        PCUrl() {
            return location.href.indexOf("gamersky.com") != -1 ? true : false;
        },
        ...mapState(["modals"]),
    }
};
</script>

<style scoped lang="scss">
// Intro
.intro {
    text-align: center;
    width: 50%;
    font-size: 0.8em;
    position: absolute;
    padding: 10px;
    background: rgba(0, 0, 0, 0.5);
    border: 3px solid black;
    border-radius: 10px;
    z-index: 3;
    a {
        color: white;
    }
    img {
        position: absolute;
        bottom: 100%;
        left: 50%;
        width: 25vh;
        margin-left: -12.5vh;
        margin-bottom: 2vh;
        max-width: 192px;
        border-radius: 50%;
        box-shadow: 0 0 10px black;
        border: 3px solid black;
    }
    .footer {
        font-size: 60%;
        opacity: 0.75;
    }
    .statement {
        a {
            color: rgb(164, 164, 231);
        }
    }
}
@media screen and (max-width: 575.98px) {
    .intro {
        width: 80%;
    }
}
</style>
